import type { AhoyPropertyType } from '../types';

const AC_TO_AHOY_TYPE: Record<string, AhoyPropertyType> = {
  text: 'string',
  textarea: 'string',
  dropdown: 'string',
  radio: 'string',
  hidden: 'string',
  '': 'string',
  date: 'date',
  datetime: 'date',
  listbox: 'multi_select',
  checkbox: 'multi_select',
  number: 'number',
  currency: 'number',
};

/** Infer the Ahoy property type to create for a given ActiveCampaign field type. */
export function inferAhoyType(acFieldType: string): AhoyPropertyType {
  return AC_TO_AHOY_TYPE[acFieldType] ?? 'string';
}

/** Slugify an external field name into a valid Ahoy property-name fragment. */
export function toPropertySlug(s: string): string {
  return s.toLowerCase().replace(/[^a-z0-9]/g, '_');
}
